import React from 'react';

function Blockd({ language }) {
  // Content for both English and Hindi
  const content = {
    en: [
      {
        title: "Ashwatthama—Cursed Warrior",
        image: "images/main-attractions/block-d/block-d-1.png",
        description: `Ashwatthama’s fierce form is depicted amidst wounded Pandav soldiers. After Dron’s death, overwhelmed by rage, he unleashed the Narayanastra to massacre the Pandav lineage and attempted to kill Abhimanyu’s unborn child at night, violating the rules of war.`,
        label: "Main Attraction",
      },
      {
        title: "Dhritirashtr's Anguish",
        image: "images/main-attractions/block-d/block-d-2.png",
        description: `After the war, when the Pandavs came to meet Dhritarashtr, he attempted to kill Bhim under the pretext of an embrace. Lord Krishna intervened, replacing Bhim with an iron statue, which Dhritarashtr crushed, injuring himself. Krishna reminded him that the true blame lay not with the Pandavs but with his blind attachment and choices. In the end, Dhritarashtr realized his mistake and embraced the Pandavs with remorse.`,
        label: "Main Attraction",
      },
      {
        title: "Yudhistir's Coronation",
        image: "images/main-attractions/block-d/block-d-3.png",
        description: `After the devastating Kurukshetr war, which led to the complete destruction of the Kaurav clan, the Pandavs reclaimed their lost kingdom. Yudhishtir, the embodiment of truth and righteousness, was crowned king of Hastinapur. This coronation marked the triumph of truth and justice over deceit and injustice, symbolizing peace and prosperity for all.`,
        
      },
      {
        title: "Ascent to Heaven",
        image: "images/main-attractions/block-d/block-d-4.png",
        description: `Now you are on that sacred path where the Pandavs once walked. After ruling for many years following the war, they renounced worldly life and departed towards the Himalayas. One by one, Draupadi and the brothers perished, while only Yudhishthir, steadfast and pure, attained heaven in his mortal form.`,
        label: "Main Attraction",
      },
      {
        title: "Gandhari's curse",
        image: "images/main-attractions/block-d/block-d-5.png",
        description: `At the end of the Kurukshetr war, Gandhari, grieving the death of her sons, cursed Krishna. She declared that just as her lineage was destroyed, the Yadav dynasty too would perish. Her curse later turned into reality when a violent conflict broke out among the Yadavs, leading to their complete annihilation. Thus, even Krishna’s family could not escape the fate of destiny.`,
      },
      {
        title: "Dwarka's Submergence",
        image: "images/main-attractions/block-d/block-d-6.png",
        description: `The submerged city of Dwarka lies ahead, deeply marked by the powerful curse it endured. This site captures the poignant moment when the legendary city, associated with Lord Krishna, sank into the depths of the Arabian Sea. The submergence fulfills the prophecy linked to Gandhari’s curse, occurring after Krishna’s departure from the mortal realm. This event symbolizes the end of the Dwapar Yug and the dawn of the Kal Yug.`,
      },
      // Add other items here...
    ],
    hi: [
      {
        title: "अश्वत्थामा - श्रापित योद्धा",
        image: "images/main-attractions/block-d/block-d-1.png",
        description: `अश्वत्थामा की यह प्रभावशाली प्रतिमा उनकी वीरता और क्रूरता को दर्शाती है। महाभारत के अंतिम दिन, द्रोण की मृत्यु के बाद, उन्होंने नारायण अस्त्र से पांडव वंश का संहार किया और अभिमन्यु के अजन्मे पुत्र को मारने का प्रयास किया। यह कृत्य युद्ध के नियमों का उल्लंघन था और युद्ध की भयावहता को दर्शाता है।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "धृतराष्ट्र की वेदना",
        image: "images/main-attractions/block-d/block-d-2.png",
        description: `महाभारत युद्ध के बाद जब पांडव धृतराष्ट्र से मिलने पहुँचे, तो उन्होंने भीम को गले लगाने के बहाने मारने का प्रयास किया। भगवान कृष्ण ने समय रहते भीम को बचा लिया और उनके स्थान पर लौहप्रतिमा रख दी। प्रतिमा को तोड़ते हुए धृतराष्ट्र स्वयं घायल हो गए। कृष्ण ने उन्हें समझाया कि असली दोष पांडवों का नहीं, बल्कि उनके अपने पुत्रमोह और निर्णयों का था। अंततः धृतराष्ट्र ने अपनी भूल स्वीकार की और पांडवों को गले लगाया।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "युधिष्ठिर का राज्याभिषेक",
        image: "images/main-attractions/block-d/block-d-3.png",
        description: `युद्ध के बाद पांडवों ने अपना राज्य पुनः प्राप्त किया और युधिष्ठिर को हस्तिनापुर के सिंहासन पर बैठाया गया। उनका राज्याभिषेक सत्य और धर्म की जीत का प्रतीक था, जो शांति और समृद्धि का संदेश देता है। यह समारोह उनके संघर्ष और बलिदान की पुष्टि करता है।`,
        
      },
      {
        title: "स्वर्गलोक यात्रा",
        image: "images/main-attractions/block-d/block-d-4.png",
        description: `अब आप उस पवित्र मार्ग पर हैं जहाँ पांडव भी चले थे। युद्ध के पश्चात् कई वर्ष शासन करने के बाद, उन्होंने सांसारिक जीवन छोड़ हिमालय की ओर प्रस्थान किया। यात्रा में द्रौपदी और चारों भाइयों का निधन हुआ, केवल युधिष्ठिर सत्य और धर्म के कारण जीवित रह गए।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "गांधारी का श्राप",
        image: "images/main-attractions/block-d/block-d-5.png",
        description: `कुरुक्षेत्र युद्ध के अंत में, अपने पुत्रों की मृत्यु से शोकाकुल गांधारी ने कृष्ण को श्राप दिया। उन्होंने कहा कि जैसे उनके वंश का अंत हुआ, वैसे ही यादव वंश भी नष्ट होगा। यह श्राप भविष्यवाणी सिद्ध हुआ और यादवों के मध्य भयंकर संघर्ष में उनका पूरा वंश समाप्त हो गया। इस प्रकार भाग्य से स्वयं कृष्ण का वंश भी नहीं बच सका।`,
      },
      {
        title: "जलमग्न द्वारका",
        image: "images/main-attractions/block-d/block-d-6.png",
        description: `अब आप द्वारका की गहराई में प्रवेश कर रहे हैं। यहाँ आप भगवान कृष्ण से जुड़ी प्राचीन नगरी द्वारका के डूबने का ऐतिहासिक क्षण देख सकते हैं, जब यह अरब सागर की गहराई में समा गई। गांधारी के श्राप से जुड़ी यह भविष्यवाणी कृष्ण के नश्वर हो जाने के बाद साकार हुई। यह घटना एक युग का अंत और द्वापर युग से कलयुग में संक्रमण का प्रतीक है।`,
      },      
      // Add other items here...
    ],
  };

  return (
    <div className="main_attractions_list">
      {content[language].map((item, index) => (
        <div className="list_item" id={`ma-blockd-${index}`} key={index}>
          <div className="attraction_image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="attranction_details">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            {item.label && <span className="main-attraction-label">{item.label}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Blockd;
